<script>
import { Article } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'
import moment from 'moment'
import { get } from 'lodash'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      redirectRoute: { name: 'Articles List' },
      livePreviewIframeSrc: '/preview/article/'
    }
  },
  created() {
    if (this.form.publication_date === undefined) {
      this.$set(this.form, 'publication_date', moment().format('YYYY-MM-DD'))
    }
  },
  watch: {
    'form.title_en': {
      deep: true,
      handler(value) {
        if (value) {
          this.$set(this.form, 'og_title_en', value)
          this.$set(this.form, 'meta_title_en', value)
        }
      }
    },
    'form.lead_en': {
      handler(value) {
        if (value) {
          this.$set(this.form, 'og_description_en', value)
          this.$set(this.form, 'meta_description_en', value)
        }
      }
    },
    'form.image': {
      handler(value) {
        if (value) {
          this.$set(this.form, 'og_image', value)
        }
      }
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Title',
          modelPath: [this, 'form', 'title'],
          multilingual: true,
          required: true
        }),
        new fields.Input({
          label: 'Lead',
          required: true,
          modelPath: [this, 'form', 'lead'],
          type: 'textarea',
          multilingual: true
        }),
        new fields.Date({
          label: 'Publication date',
          type: 'date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          modelPath: [this, 'form', 'publication_date'],
          required: true
        }),
        new fields.Image({
          label: 'Image',
          modelPath: [this, 'form', 'image'],
          specificThumbnail: this.specificThumbnail
        }),
        new fields.Input({
          label: 'Image caption',
          modelPath: [this, 'form', 'caption'],
          multilingual: true
        }),
        new fields.Select({
          label: 'Image type',
          modelPath: [this, 'form', 'image_type'],
          options: [
            { label: 'Large', value: 'normal' },
            { label: 'Circle', value: 'small' },
            { label: 'Short', value: 'short' },
            { label: 'Narrow', value: 'narrow' }
          ]
        })
      ]
    }
  },
  computed: {
    service() {
      return Article
    },
    url() {
      const selectedLanguage = this.$store.state.selectedLanguage
      const currentPageSlug = get(this, ['form', `slug_${selectedLanguage}`])
      return `${process.env.VUE_APP_FRONTEND_URL}/articles/${currentPageSlug}/`
    },
    specyficThumbnail() {
      if (this.form.image_type === 'narrow') {
        return 'normal'
      }
      return this.form.image_type
    }
  }
}
</script>
